import sanitizeHtml from 'sanitize-html'
export default (el, html, isSsr) => {
  const { value } = html
  const allowedAttributesValue = ['style', 'href', 'src']
  const allowedAttributes = sanitizeHtml.defaults.allowedAttributes
  allowedAttributes['*'] = allowedAttributesValue
  const allowedTags = sanitizeHtml.defaults.allowedTags.concat(['img'])
  const allowedClasses = {
    '*': [
      'colored-title',
      'link--basic',
      'red-text',
      'desktop-only',
      'list-item',
      'section-big',
      'section-small',
      'table-wrapper',
      'arrow-right',
    ],
  }
  if (!value) {
    el.innerHTML = null
  } else {
    const sanitized = sanitizeHtml(value, {
      allowedClasses,
      allowedAttributes,
      allowedTags,
    })
    if (isSsr && el.data) {
      el.data.domProps = {
        innerHTML: sanitized,
      }
    } else {
      el.innerHTML = sanitized
    }
  }
}
